<template>
  <div class="chat-container">
    <div class="chat_top">
      <el-tooltip placement="right" effect="dark" content="返回首页">
        <el-button
          type="primary"
          circle
          icon="el-icon-arrow-left"
          @click="onToReturn"
        ></el-button>
      </el-tooltip>
      <div style="height: 10px"></div>
      <el-tooltip placement="right" effect="dark" content="新对话">
        <el-button
          type="primary"
          circle
          icon="el-icon-chat-line-square"
          @click="onNewDialogue"
        ></el-button>
      </el-tooltip>
    </div>
    <div
      class="chat-box scrollable-content"
      ref="scrollContainer"
      @scroll="handleScroll"
    >
      <div
        v-for="(message, index) in messages"
        :key="index"
        :class="`message ${message.sender}`"
      >
        <div class="avatar">{{ message.sender === "user" ? "我" : "AI" }}</div>
        <div class="content" v-loading.body="!message.text">
          <div v-if="message.text">
            <vue-markdown
              :source="message.text"
              :options="options"
            ></vue-markdown>
          </div>
        </div>
      </div>
    </div>
    <el-input
      v-model="input"
      placeholder="请输入消息..."
      @keyup.enter.native="sendMessage"
      class="input-box"
    >
      <template slot="append">
        <el-button
          @click="sendMessage"
          icon="el-icon-s-promotion"
          style="background: #409eff; color: #fff; border-radius: 0 4px 4px 0;border: 1px solid #409eff;"
        >
        </el-button>
      </template>
    </el-input>
  </div>
</template>
  
  
  <script>
import hljs from "highlight.js";
import VueMarkdown from "vue-markdown";
import "highlight.js/styles/default.css";
import Axios from "axios";
import config from "../../../config";
const baseUrl = config.API_HOST;
console.log(baseUrl);

export default {
  components: { VueMarkdown },
  data() {
    return {
      options: {
        emoji: true,
      },
      messages: [],
      input: "",
      eventSource: null,
      isCode: false,
      language: "",
      lastAiMessage: "",
      sessionId: "",
      autoScroll: true, // 是否自动滚动
    };
  },

  methods: {
    onToReturn() {
      $utils.url.push({ path: "/index" });
    },
    onNewDialogue() {
      this.messages = [];
      this.lastAiMessage = "";
      this.sessionId = "";
      this.isCode = false;
      this.input = "";
      this.messages.push({
        sender: "ai",
        text: "Hi，我是医维保AI助手小E,很高兴遇见你！",
      });
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;

      container.scrollTop = container.scrollHeight;
    },
    handleScroll() {
      const container = this.$refs.scrollContainer;
      this.autoScroll =
        container.scrollTop + container.clientHeight >= container.scrollHeight;
    },
    highlightedCode(code) {
      if (!code) return "";

      if (code.includes("```") && !this.isCode) {
        this.isCode = true;
        const spliceLength2 = code.lastIndexOf("`");
        if (spliceLength2) {
          this.language = code.slice(spliceLength2 + 1);
        }

        return;
      }
      if (this.isCode) {
        if (code.includes("```")) {
          this.isCode = false;
          return;
        } else {
          return hljs.highlight(this.language, code).value;
        }
      } else {
        return hljs.highlight("plaintext", code).value;
      }
    },
    async onSaveInput() {
      let q = {
        assistantInput: this.lastAiMessage,
        sessionId: this.sessionId,
      };
      let res = Axios.post(baseUrl + "/admin/system/deepseek/saveReply", q);
      console.log(res);
    },
    sendMessage() {
      if (!this.input.trim()) return;

      // 添加用户消息
      this.messages.push({ text: this.input, sender: "user" });
      if (this.autoScroll) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
      this.onNewEventSource(this.input);
      // 清空输入框
      this.input = "";
    },
    handleServerMessage(event) {
      if (event.data.includes(`\"message\":[DONE]`)) {
        this.onSaveInput();
        this.eventSource.close();
      } else {
        const dataAll = JSON.parse(event.data);
        const sessionId = dataAll.sessionId;
        const data = dataAll.message;
        let text =
          // data.Choices[0].Delta.ReasoningContent
          //   ? data.Choices[0].Delta.ReasoningContent
          //   :
          data.Choices[0].Delta.Content ? data.Choices[0].Delta.Content : "";
        this.sessionId = sessionId;
        // 逐字展示效果
        this.typeWriterEffect(text, this.messages.length - 1);
      }
    },
    typeWriterEffect(text, index) {
      let currentText = this.messages[index].text
        ? this.messages[index].text
        : "";
      currentText += text;
      this.lastAiMessage = currentText;
      if (this.autoScroll) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
      this.$set(this.messages[index], "text", currentText);
    },
    onNewEventSource(text) {
      let sessionId = "";
      if (this.lastAiMessage) {
        sessionId = `&sessionId=${this.sessionId}`;
      }
      let url = baseUrl + "/admin/system/deepseek/chat?";
      let userinput = `userInput=${text}`;
      this.eventSource = new EventSource(
        url + userinput + (sessionId ? sessionId : "")
      );
      this.eventSource.onmessage = this.handleServerMessage;
      this.eventSource.onopen = (e) => {
        this.messages.push({ sender: "ai" });
      };
      // 监听错误事件
      this.eventSource.onerror = (err) => {
        console.error("EventSource failed:", err);
        if (this.autoScroll) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
        this.messages.push({
          text: "服务器连接失败，请稍后再试。",
          sender: "ai",
        });
        this.eventSource.close();
      };
    },
  },
  mounted() {
    this.messages.push({
      sender: "ai",
      text: "Hi，我是医维保AI助手小E,很高兴遇见你！",
    });
    hljs.highlightAll();
  },
};
</script>
  
  <style scoped lang="scss">
.chat_top {
  position: fixed;
  left: 16px;
  top: 16px;
  display: flex;
  flex-direction: column;
}
pre {
  background-color: #f4f4f4;
  overflow-x: auto;
  white-space: pre-wrap; /* 保持空白符序列，但是正常换行 */
  word-wrap: break-word; /* 兼容旧版浏览器 */
  overflow-wrap: break-word; /* 同 word-wrap */
}
.chat-container {
  display: flex;
  flex-direction: column;
  height: 95vh;
  width: 100%;
  max-width: 75vw;
  margin: 0 auto;
}

.chat-box {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  border-bottom: 1px solid #ddd;
}
/* 定义整个滚动条的样式 */
.scrollable-content::-webkit-scrollbar {
  width: 0px; /* 滚动条的宽度 */
}

/* 定义滚动条轨道的样式 */
.scrollable-content::-webkit-scrollbar-track {
  background-color: #eaeaea;
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
}

/* 定义滚动条滑块的样式 */
.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

/* 定义滚动条滑块的悬停样式 */
.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.message.user {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
}

.content {
  max-width: 70%;
  min-width: 40px;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
}

.user .content {
  background-color: #007bff;
  color: white;
}

.input-box {
  padding: 16px;
}
</style>